import Request from "../../../../shared/utils/_request";
import sse from './sse'
class aiApi {
  constructor() {}
  //获取历史记录
  getHistoryList(payload) {
    return Request.http("/aibiz/bot/ie/chat/session/history", payload,'java');
  }
  //更新标题
  updateTitle(payload){
    return Request.http("/aibiz/bot/chat/session/update", payload,'java');
  }
  //删除记录
  deleteHistory(payload){
    return Request.http("/aibiz/bot/chat/session/delete", payload,'java');
  }
  //查询消息列表
  getHistory(payload){
    return Request.http("/aibiz/bot/ie/chat/message/history", payload,'java');
  }
  //查询提示词模板,1, 运营侧-推荐问题,2, 猎头侧-推荐语
  getModle(payload){
    return Request.http("/aibiz/bot/ie/getPromptWordTemplates", payload,'java');
  }
  //会话
  getChat(payload){
    return Request.http("/aibiz/bot/ie/chat", payload,'java');
  }
  //sse 会话
  chat(conversation,msg,cb){
    return sse.fetchsse('/aibiz/bot/ie/chat',conversation,msg,cb);
  }
}

export const aiapi = new aiApi();
